<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ $t("headers.vehicleNfc") }}</h3>
            </div>
            <div class="card-body">
                <div class="row mb-5 align-items-end">
                    <div class="col-12 col-md-4">
                        <label class="form-label fw-bold">
                            {{ $t("vehicleNfcEntry.licencePlate") }}
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="filters.licence_plate"
                            :placeholder="$t('vehicleNfcEntry.licencePlate')"
                        />
                    </div>

                    <div class="col-12 col-md-3">
                        <label class="form-label fw-bold">
                            {{ $t("vehicleNfcEntry.dateFrom") }}
                        </label>
                        <input
                            type="date"
                            class="form-control"
                            v-model="filters.date_from"
                        />
                    </div>

                    <div class="col-12 col-md-3">
                        <label class="form-label fw-bold">
                            {{ $t("vehicleNfcEntry.dateTo") }}
                        </label>
                        <input
                            type="date"
                            class="form-control"
                            v-model="filters.date_to"
                        />
                    </div>

                    <div class="col-12 col-md-2 d-flex">
                        <button
                            class="btn btn-secondary w-100"
                            @click="resetFilters"
                        >
                            {{ $t("utils.clearFilters") }}
                        </button>
                    </div>
                </div>

                <VehicleEntryProvider
                    :api-url="`/${$route.params.slug}/vehicle-nfc/entries`"
                    :filters="filters"
                    v-slot="p"
                >
                    <VehicleNfcEntryTable
                        :items="p.items"
                        :total-count="p.totalCount"
                        :page="p.page"
                        :per-page="p.perPage"
                        @page-change="p.setPage"
                        @per-page-change="p.setPerPage"
                    />
                </VehicleEntryProvider>
            </div>
        </div>
    </div>
</template>

<script>
import VehicleNfcEntryTable from '@/components/VehicleNfcEntryTable.vue';
import VehicleEntryProvider from '@/components/VehicleEntryProvider.vue';

    export default {
        components: {
            VehicleNfcEntryTable,
            VehicleEntryProvider,
        },
        data() {
            return {
                filters: {
                    licence_plate: "",
                    date_from: "",
                    date_to: "",
                }
            }
        },
        methods: {
            resetFilters() {
                this.filters.licence_plate = "";
                this.filters.date_from = "";
                this.filters.date_to = "";
            },
        }
    }
</script>
